import {
  createYoutubeIframe,
  nonEmptyString,
} from "../app/media";
import {
  safeHttpUrl,
  SUCHARD_VIDEO_ORIGINS,
  YOUTUBE_POSTER_ORIGINS,
} from "../app/safe-url";

export function createYoutubePreview(video, onPlay) {
  const button = document.createElement("button");
  button.className = "youtube-player__preview";
  button.type = "button";
  button.setAttribute("aria-label", `Reproducir ${video.title}`);

  const posterUrl = nonEmptyString(video.posterUrl)
    ? safeHttpUrl(video.posterUrl, { allowedOrigins: YOUTUBE_POSTER_ORIGINS })
    : null;
  const backgroundVideoUrl = nonEmptyString(video.backgroundVideoUrl)
    ? safeHttpUrl(video.backgroundVideoUrl, { allowedOrigins: SUCHARD_VIDEO_ORIGINS })
    : null;

  if (backgroundVideoUrl) {
    const backgroundVideo = document.createElement("video");
    backgroundVideo.className = "youtube-player__background-video";
    backgroundVideo.src = backgroundVideoUrl;
    backgroundVideo.autoplay = true;
    backgroundVideo.loop = true;
    backgroundVideo.muted = true;
    backgroundVideo.defaultMuted = true;
    backgroundVideo.playsInline = true;
    backgroundVideo.preload = "metadata";
    backgroundVideo.controls = false;
    backgroundVideo.disablePictureInPicture = true;
    backgroundVideo.setAttribute("muted", "");
    backgroundVideo.setAttribute("aria-hidden", "true");
    if (posterUrl) backgroundVideo.poster = posterUrl;
    button.append(backgroundVideo);
  } else if (posterUrl) {
    const image = document.createElement("img");
    image.src = posterUrl;
    image.alt = "";
    image.loading = "lazy";
    image.decoding = "async";
    button.append(image);
  }

  const playIcon = document.createElement("span");
  playIcon.className = "youtube-player__play-icon";
  playIcon.setAttribute("aria-hidden", "true");
  button.append(playIcon);
  button.addEventListener("click", () => {
    onPlay?.();
  });
  return button;
}

export function createYoutubeBackdrop(video) {
  const backdrop = document.createElement("div");
  backdrop.className = "youtube-player__backdrop";
  backdrop.setAttribute("aria-hidden", "true");

  const posterUrl = nonEmptyString(video.posterUrl)
    ? safeHttpUrl(video.posterUrl, { allowedOrigins: YOUTUBE_POSTER_ORIGINS })
    : null;
  const backgroundVideoUrl = nonEmptyString(video.backgroundVideoUrl)
    ? safeHttpUrl(video.backgroundVideoUrl, { allowedOrigins: SUCHARD_VIDEO_ORIGINS })
    : null;

  if (backgroundVideoUrl) {
    const backgroundVideo = document.createElement("video");
    backgroundVideo.className = "youtube-player__background-video";
    backgroundVideo.src = backgroundVideoUrl;
    backgroundVideo.autoplay = true;
    backgroundVideo.loop = true;
    backgroundVideo.muted = true;
    backgroundVideo.defaultMuted = true;
    backgroundVideo.playsInline = true;
    backgroundVideo.preload = "metadata";
    backgroundVideo.controls = false;
    backgroundVideo.disablePictureInPicture = true;
    backgroundVideo.setAttribute("muted", "");
    if (posterUrl) backgroundVideo.poster = posterUrl;
    backdrop.append(backgroundVideo);
  } else if (posterUrl) {
    const image = document.createElement("img");
    image.src = posterUrl;
    image.alt = "";
    image.loading = "eager";
    image.decoding = "async";
    backdrop.append(image);
  }

  return backdrop;
}

export function createYoutubePlayer(container, video, options = {}) {
  let playing = false;

  const renderPreview = () => {
    playing = false;
    container.replaceChildren(createYoutubePreview(
      video,
      () => play({ autoplay: true, muted: false }),
    ));
  };

  const play = ({ autoplay = false, muted = false } = {}) => {
    const iframe = createYoutubeIframe(video, {
      autoplay,
      loop: options.loop === true,
      loading: options.loading,
      muted,
    });
    if (!iframe) return false;

    options.onPlay?.();
    playing = true;
    container.replaceChildren(iframe);
    return true;
  };

  renderPreview();

  return {
    play,
    reset() {
      if (!playing) return;
      renderPreview();
      options.onStop?.();
    },
    stop() {
      if (!playing) return;
      renderPreview();
      options.onStop?.();
    },
    get playing() {
      return playing;
    },
  };
}
